import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { Helmet } from 'react-helmet';
import { Hero } from '~/components/Hero';
import { Heading } from '~/elements/Heading';
import { Ryanbot } from '~/components/Ryanbot';

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
  }
`;

const LogoSection = styled.div`
  height: 100vh;
  width: 100vw;
  overflow: hidden;
`;

const LogoContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  max-width: 800px;
  margin: 0 auto;
  width: 100%;
  height: 100%;
`;

const ChatContainer = styled.div`
  height: 100%;
  min-height: 400px;
  /* width: 100%; */
  padding: 2rem;
`;

const LogoPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Column Logo Selector</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <GlobalStyle />
      <LogoSection>
        <LogoContent>
          <ChatContainer>
            <Ryanbot />
          </ChatContainer>
        </LogoContent>
      </LogoSection>
    </>
  );
};

export default LogoPage;
